import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../config.service';
import { ActionResult } from 'src/app/models/auth/_models/action-result';




@Injectable({
  providedIn: 'root',
})
export class ProcessHTTPService {
  constructor(private http: HttpClient,private configService: ConfigService) { }

  // public methods
  getprocessdata(user:string){
    return this.http.get<ActionResult<any>>(`${this.configService.config.apiMainSeven}/Process?User=${user}`);
  }
  GetReport(programa:string){
    return this.http.get<ActionResult<any>>(`${this.configService.config.apiSecuritySeven}/GetReport?programa=${programa}`);
  }
  getprocesupdate(cadena:string){
    return this.http.get<ActionResult<any>>(`${this.configService.config.apiMainSeven}/Process/update?cadena=${cadena}`);
  }

  getprocesinfo(id : number, table:string, type:string){
    return this.http.get<ActionResult<any>>(`${this.configService.config.apiMainSeven}/Process/info?id=${id}&tabla=${table}&tipo=${type}`);  
  }
}
